
export default {
  name: 'PageFAQs',

  head() {
    return {
      title: 'Frequently asked questions',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: ''
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Frequently asked questions',
        image: require('~/assets/images/backgrounds/faqs-hero.jpg'),
        alt: 'Sausage dog in a paddock'
      }
    }
  }
}
